import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { format, startOfMonth, endOfMonth } from 'date-fns';
import '../../styles/ImpPlanning.css';

const ImpPlanning = ({ token }) => {
  const [showDateRangePicker, setShowDateRangePicker] = useState(false);
  const [dateRange, setDateRange] = useState({ 
    start: format(startOfMonth(new Date()), 'yyyy-MM-dd'), 
    end: format(endOfMonth(new Date()), 'yyyy-MM-dd') 
  });
  const [trainValues, setTrainValues] = useState([]);
  const [selectedTrains, setSelectedTrains] = useState([]);
  const [trainDropdownOpen, setTrainDropdownOpen] = useState(false);
  const trainDropdownRef = useRef(null);

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  useEffect(() => {
    if (token) {
      axios.get(`${API_URL}/api/planning/trains`, {
        headers: { Authorization: token },
      })
        .then(res => setTrainValues(res.data || []))
        .catch(err => console.error('Erreur chargement types de train :', err));
    }
  }, [token, API_URL]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (trainDropdownRef.current && !trainDropdownRef.current.contains(e.target)) {
        setTrainDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleTrain = (val) => {
    setSelectedTrains(prev =>
      prev.includes(val) ? prev.filter(v => v !== val) : [...prev, val]
    );
  };

  const generatePDF = async () => {
    if (!dateRange.start || !dateRange.end) {
      alert("Veuillez sélectionner une date de début et une date de fin.");
      return;
    }

    try {
      const params = {
        date_start: dateRange.start,
        date_end: dateRange.end,
      };
      if (selectedTrains.length > 0) {
        params.trains = selectedTrains.join(',');
      }

      // Appeler la route backend pour générer le PDF
      const response = await axios.get(`${API_URL}/api/planning/pdf`, {
        headers: { Authorization: token },
        params,
        responseType: 'blob', // Important pour recevoir un fichier binaire
      });

      // Créer un lien pour télécharger le fichier
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `planning_${format(new Date(dateRange.start), 'yyyyMMdd')}_${format(new Date(dateRange.end), 'yyyyMMdd')}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);

      setShowDateRangePicker(false);
    } catch (error) {
      console.error("Erreur lors de la génération du PDF :", error);
      alert("Erreur lors de la génération du PDF.");
    }
  };

  return (
    <>
      <button onClick={() => setShowDateRangePicker(true)} className="button-benevoles">
        Exporter en PDF
      </button>
      {showDateRangePicker && (
        <div className="date-range-picker-benevoles">
          <h4>Sélectionner une plage de dates</h4>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
            <label style={{ whiteSpace: 'nowrap' }}>Du</label>
            <input
              type="date"
              value={dateRange.start}
              onChange={(e) => setDateRange({ ...dateRange, start: e.target.value })}
              style={{ flex: 1, minWidth: '130px' }}
            />
            <label style={{ whiteSpace: 'nowrap' }}>au</label>
            <input
              type="date"
              value={dateRange.end}
              onChange={(e) => setDateRange({ ...dateRange, end: e.target.value })}
              style={{ flex: 1, minWidth: '130px' }}
            />
          </div>
          <div>
            <label>Types de train :</label>
            <div className="imp-train-multiselect" ref={trainDropdownRef}>
              <button
                type="button"
                className="imp-train-toggle"
                onClick={() => setTrainDropdownOpen(!trainDropdownOpen)}
              >
                {selectedTrains.length === 0 ? 'Tous les trains' : selectedTrains.join(', ')}
                <span style={{ marginLeft: 8 }}>{trainDropdownOpen ? '▲' : '▼'}</span>
              </button>
              {trainDropdownOpen && (
                <div className="imp-train-dropdown">
                  {trainValues.length === 0 ? (
                    <div className="imp-train-empty">Aucun type disponible</div>
                  ) : (
                    trainValues.map(val => (
                      <label key={val} className="imp-train-item">
                        <input
                          type="checkbox"
                          checked={selectedTrains.includes(val)}
                          onChange={() => toggleTrain(val)}
                        />
                        <span>{val}</span>
                      </label>
                    ))
                  )}
                </div>
              )}
            </div>
          </div>
          <div>
            <button onClick={generatePDF} className="GenererPdf-button">
              Générer le PDF
            </button>
            <button onClick={() => setShowDateRangePicker(false)} className="GenererPdf-button">
              Annuler
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ImpPlanning;
